var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#contact'),expression:"'#contact'"}],staticClass:"sticky-cta",attrs:{"href":"/contact"},on:{"click":_vm.trackClick}},[_c('span',[_vm._v("Бесплатная консультация")])])}
var staticRenderFns = []

export { render, staticRenderFns }